import React from "react";
import { UseFormReturn } from "react-hook-form";
import { Form } from "../../../components/ui/common/form";
import { FormSearchSelect } from "../../../components/ui/Input/FormSearchSelect";

interface ProductSelectorProps {
  form: UseFormReturn<{ salesUnitId: string }>;
  options: Array<{ id: string; title: string; value: string }>;
  isLoading: boolean;
  onChangeValue: (value: string) => void;
}

/**
 * ProductSelector Component
 * Single Responsibility: Product selection dropdown
 */
export const ProductSelector: React.FC<ProductSelectorProps> = ({
  form,
  options,
  isLoading,
  onChangeValue
}) => {
  return (
    <div className="tw-flex tw-flex-col sm:tw-flex-row sm:tw-items-center sm:tw-justify-between tw-gap-4">
      <Form {...form}>
        <FormSearchSelect
          control={form.control}
          name="salesUnitId"
          label="Product Name"
          placeholder="Search products..."
          options={options}
          disabled={isLoading}
          loading={isLoading}
          required={false}
          onChange={onChangeValue}
        />
      </Form>
    </div>
  );
};
